import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';

import { ButtonModule } from '@paymash/ui-kit';
import {
  SocialMediaComponent,
  CompanyInfoComponent,
  NotificationComponent,
  StoreInfoComponent,
  BackButtonComponent,
  CompanyLogoComponent,
  ProceedButtonComponent,
  ProceedFooterComponent,
  ServiceDurationAndPriceComponent,
  MobileAppointmentTableComponent,
  AppointmentDateWidgetComponent,
  AppointmentListComponent,
  AppointmentExternalNoteComponent,
  IconedRadioComponent,
} from './components';
import { FormatMoneyPipe, CustomAsyncPipe, TimePipe, SafeHtmlPipe, LocalizedDatePipe, OrderByPipe } from './pipes';
import { NoEmployeeSelectionComponent } from './components/no-employee-selection/no-employee-selection.component';
import { NgZorroAntdModule } from '@public-page/ng-zorro-antd/ng-zorro-antd.module';
import { DateWidgetComponent } from '@modules/shared/components';

@NgModule({
  declarations: [
    SocialMediaComponent,
    CompanyInfoComponent,
    NotificationComponent,
    StoreInfoComponent,
    BackButtonComponent,
    CompanyLogoComponent,
    ProceedButtonComponent,
    FormatMoneyPipe,
    CustomAsyncPipe,
    TimePipe,
    SafeHtmlPipe,
    OrderByPipe,
    NoEmployeeSelectionComponent,
    ProceedFooterComponent,
    LocalizedDatePipe,
    ServiceDurationAndPriceComponent,
    MobileAppointmentTableComponent,
    AppointmentDateWidgetComponent,
    DateWidgetComponent,
    AppointmentListComponent,
    AppointmentExternalNoteComponent,
    IconedRadioComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBackgroundColour: 'rgba(255,255,255,0.9)',
      backdropBorderRadius: '0',
      primaryColour: '#dcdcdc',
      secondaryColour: 'rgba(51,51,51,0.5)',
      tertiaryColour: '#dcdcdc',
    }),
  ],
  exports: [
    NgxLoadingModule,
    TranslateModule,
    ButtonModule,
    FormsModule,
    SocialMediaComponent,
    CompanyInfoComponent,
    NotificationComponent,
    StoreInfoComponent,
    BackButtonComponent,
    CompanyLogoComponent,
    ProceedButtonComponent,
    FormatMoneyPipe,
    CustomAsyncPipe,
    TimePipe,
    SafeHtmlPipe,
    OrderByPipe,
    NoEmployeeSelectionComponent,
    ProceedFooterComponent,
    LocalizedDatePipe,
    ServiceDurationAndPriceComponent,
    MobileAppointmentTableComponent,
    AppointmentDateWidgetComponent,
    DateWidgetComponent,
    AppointmentListComponent,
    AppointmentExternalNoteComponent,
    IconedRadioComponent,
  ],
})
export class SharedModule {}
